import { ArticleFooterContributorInfoProps } from "design-system/components/pages/article-page/article-footer/article-footer-contributor-info";
import { createContentfulProps } from "frontend/contentful/lib/create-contentful-props";
import { isContentType } from "frontend/contentful/lib/is-content-type";
import {
  ContributorEntry,
  PersonEntry,
  PersonWrapperEntry,
} from "frontend/contentful/schema/semantics";
import { useContentful } from "frontend/hooks/use-contentful";

export const createArticleContributorProps = createContentfulProps<
  ContributorEntry,
  ArticleFooterContributorInfoProps
>(({ entry: entity, createEditAttributes }) => {
  const { getEntryUrl, getEntry, getEntityName } = useContentful();

  const contributorEntry = getEntry(entity);

  if (!contributorEntry) return;

  const personEntry = getEntry(contributorEntry.fields.person);

  const person = isContentType<PersonWrapperEntry>("personWrapper", personEntry)
    ? getEntry(personEntry.fields.person)
    : personEntry;

  if (!person) return;

  const link =
    "bioURL" in person.fields && person.fields.bioURL
      ? getEntryUrl(person.fields.bioURL)
      : undefined;

  const typeSet = new Set<string>();

  if (contributorEntry.fields.contributorType) {
    contributorEntry.fields.contributorType.forEach((typeEntry) => {
      const resolvedTypeEntry = getEntry(typeEntry);
      const typeName = resolvedTypeEntry?.fields.title;
      if (typeName) typeSet.add(typeName);
    });
  }

  const type =
    typeSet.size > 0
      ? Array.from(typeSet)
      : Array.isArray(contributorEntry.fields.type)
        ? contributorEntry.fields.type
        : contributorEntry.fields.type
          ? [contributorEntry.fields.type]
          : undefined;

  const props: ArticleFooterContributorInfoProps = {
    type,
    name: getEntityName(personEntry),
    link,
    editAttributes: {
      name: createEditAttributes({
        entry: person,
        fieldId: isContentType<PersonEntry>("person", person)
          ? "firstName"
          : "name",
      }),
      email:
        "email" in person.fields
          ? createEditAttributes({
              entry: person,
              fieldId: "email",
            })
          : undefined,
      phone:
        "phone" in person.fields
          ? createEditAttributes({
              entry: person,
              fieldId: "phone",
            })
          : undefined,
    },
  };

  return props;
});
